<template lang="pug">
    //- Dots
    .d-flex.flex-row.align-center(:class="absolute ? 'top-right':''")
        div(v-for="index of length")
            .mx-1.dot(:class="index === activeDot ? 'dot-active':'dot-inactive'")
</template>

<script>
  export default {
    props: {
      length: {
        type: Number,
        default: () => 2,
      },
      activeDot: {
        type: Number,
        default: () => 0,
      },
      absolute: {
        type: Boolean,
        default: () => false,
      },
    },
  }
</script>

<style scoped>
    .dot{
      width: 12px;
      height: 12px;
      border-radius: 50px;
    }
    .dot-inactive{
      background: #3ea7ac;
    }
    .dot-active{
      background: white !important;
    }
    .top-right{
      position: absolute;
      top: 10px;
      right: 10px;
    }
</style>
